import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import { HasFields } from "@insite/client-framework/Types/ContentItemModel";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import VerticalColumnCell from "@insite/content-library/Components/VerticalColumnCell";
import VerticalColumnContainer from "@insite/content-library/Components/VerticalColumnContainer";
import Accordion, { AccordionStyle } from "@insite/mobius/Accordion/Accordion";
import {
    AccordionSectionHeader,
    AccordionSectionPanel,
    ManagedAccordionSection,
} from "@insite/mobius/AccordionSection";
import AccordionSection from "@insite/mobius/AccordionSection/AccordionSection";
import { StyledButton } from "@insite/mobius/Clickable/Clickable";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps, GridOffset } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import { IconWrapper } from "@insite/mobius/Icon/Icon";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography from "@insite/mobius/Typography/Typography";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import parse from "html-react-parser";

import React, { useState } from "react";

import { css } from "styled-components";

const enum fields {
    sections = "sections",
    title = "title",
    subtitle = "subtitle",
    image = "image",
}

interface SectionModel {
    fields: {
        accordionText: string;
        subAccordionText: string;
    };
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.sections]: SectionModel[];
        [fields.title]: string;
        [fields.subtitle]: string;
        [fields.image]: string;
    };
}

type Props = OwnProps;

export interface InfoCardStyles {
    Title?: InjectableCss;
    SubTitle?: InjectableCss;
    infoCardContainer?: GridContainerProps;
    infoCardLink?: LinkPresentationProps;
    infoCardDiv?: GridItemProps;
    accordionText?: InjectableCss;
    subAccordionText?: InjectableCss;
    main?: InjectableCss;
}

export const infoCardStyles: InfoCardStyles = {
    infoCardContainer: {
        css: css`
            margin: 0 auto;
            display: flex;
            flex-wrap: wrap;
            ${GridOffset} {
                justify-content: none !important;
                align-items: none !important;
            }

            ${({ theme }: { theme: BaseTheme }) => breakpointMediaQueries(theme, [css``, css``, css``])}
        `,
    },
    infoCardDiv: {
        width: [12, 12, 12, 10, 3],
        css: css`
            display: flex;
            flex-direction: column;
            margin: 0 auto !important;
            height: fit-content !important;
            ${AccordionStyle} {
                width: 100%;
                ${AccordionSectionPanel} {
                    background-color: transparent;
                    border: 1px solid ${getColor("primary")};
                    padding: 1em;
                }
                ${TypographyStyle} {
                    white-space: normal !important;
                    color: ${getColor("primary.contrast")} !important;
                    .ulDiscClass {
                        ${({ theme }: { theme: BaseTheme }) =>
                            breakpointMediaQueries(theme, [
                                css``,
                                css``,
                                css`
                                    padding: 0 0 0 18px !important;
                                `,
                                css`
                                    padding: 0 0 0 18px !important;
                                `,

                                null,
                                null,
                            ])}
                        span {
                            font-size: 14.4px;
                            ${({ theme }: { theme: BaseTheme }) =>
                                breakpointMediaQueries(theme, [
                                    css`
                                        font-size: 13px;
                                    `,
                                    css`
                                        font-size: 13px;
                                    `,
                                    css`
                                        font-size: 13px;
                                    `,
                                    css`
                                        font-size: 13px;
                                    `,

                                    null,
                                    null,
                                ])}
                        }
                    }
                    .ulGenericDiscClass {
                        list-style: none !important;
                        padding: 0 !important;
                        margin: 0 !important;
                        .liGenericDiscClass {
                            p {
                                font-size: 16px;
                                color: ${getColor("primary.contrast")};
                                ${({ theme }: { theme: BaseTheme }) =>
                                    breakpointMediaQueries(theme, [
                                        css`
                                            font-size: 13px;
                                        `,
                                        css`
                                            font-size: 13px;
                                        `,
                                        css`
                                            font-size: 13px;
                                        `,
                                        css`
                                            font-size: 13px;
                                        `,

                                        null,
                                        null,
                                    ])}
                            }
                            h6,
                            a {
                                font-size: 0.875rem;
                                border-radius: 3px;
                                background-color: ${getColor("primary")};
                                transition: all 0.4s;
                                width: 100%;
                                padding: 15px 73px 15px 70px;
                                font-weight: 600;
                                display: inline-block;
                                margin-bottom: 15px;
                                text-align: center;
                                ${({ theme }: { theme: BaseTheme }) =>
                                    breakpointMediaQueries(theme, [
                                        css`
                                            padding: 4px 4px;
                                        `,
                                        css`
                                            padding: 4px 4px;
                                        `,
                                        css`
                                            padding: 2px 2px !important;
                                        `,
                                        css`
                                            padding: 9px 9px !important;
                                        `,
                                        null,
                                        null,
                                    ])}
                                &:hover {
                                    color: ${getColor("primary.contrast")} !important;
                                }
                            }

                            .linkClass {
                                background: none;
                                padding: 0;
                                span {
                                    color: #ff0 !important;
                                }
                            }
                        }
                    }
                }
            }
            ${AccordionSectionHeader} {
                button[aria-expanded="true"] {
                    background-color: ${getColor("primary")} !important;
                    color: ${getColor("primary.contrast")};
                    border-color: ${getColor("primary")};
                    span {
                        font-family: "Roboto-Bold" !important;
                    }
                }
                button {
                    border: 0;
                    background: none;
                    padding: 0px;
                    color: ${getColor("primary")};
                    background-color: #999;
                    border: 1px solid #999;
                    padding: 0.5em 1em;
                    word-break: break-word;
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(theme, [
                            css``,
                            css``,
                            css`
                                padding: 0 !important;
                            `,
                            null,
                            null,
                        ])}
                    ${TypographyStyle} {
                        font-size: 16px;
                        pointer-events: none;
                        color: ${getColor("primary.contrast")};
                        margin: 0 auto !important;
                        ${({ theme }: { theme: BaseTheme }) =>
                            breakpointMediaQueries(theme, [
                                css``,
                                css``,
                                css`
                                    font-size: 12px;
                                `,
                                null,
                                null,
                            ])}
                    }
                    ${IconWrapper} {
                        svg {
                            color: ${getColor("primary.contrast")};
                        }
                    }
                }
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding: 9px 20px;
                    `,
                    css`
                        padding: 9px 20px;
                    `,
                    css`
                        padding: 9px 20px;
                        flex-basis: 25% !important;
                        max-width: 68% !important;
                    `,
                    css`
                        padding: 9px 20px;
                        flex-basis: 24% !important;
                        max-width: 68% !important;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    infoCardLink: {
        css: css`
            width: 100%;
            span {
                width: 100%;
            }
        `,
    },
    accordionText: {
        css: css`
            font-style: normal;
            font-weight: 700;
            font-size: 26px;
            line-height: 28px;
            margin-top: 16px;
            text-align: center;
            color: ${getColor("text.accent")};
            font-family: "Roboto-bold";
            text-transform: capitalize;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin-top: 8px;
                        width: max-content;
                    `,
                    css`
                        margin-top: 8px;
                        width: max-content;
                    `,
                    css`
                        margin-top: 8px;
                        width: max-content;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    subAccordionText: {
        css: css`
            font-style: normal;
            font-weight: 700;
            font-size: 14.4px;
            line-height: 28px;
            width: max-content;
            text-align: center;
            color: ${getColor("text.accent")};
            font-family: "Roboto-medium";
            text-transform: capitalize;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin-top: 8px;
                        width: initial;
                    `,
                    css`
                        margin-top: 8px;
                        width: initial;
                    `,
                    css`
                        margin-top: 8px;
                        width: max-content;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    Title: {
        css: css`
            font-size: 28px;
            text-align: center;
            font-family: "Roboto-bold";
            padding-bottom: 40px;
            margin-top: 0;
            text-transform: capitalize;
            font-weight: 400;
            color: ${getColor("primary.contrast")};
            margin-bottom: 24px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin-bottom: 14px;
                        padding-bottom: 14px;
                        font-size: 24px;
                        text-align: center;
                        margin-top: 0;
                        text-transform: capitalize;
                        font-weight: 400;
                    `,
                    css`
                        margin-bottom: 14px;
                        padding-bottom: 14px;
                        font-size: 24px;
                        text-align: center;
                        margin-top: 0;
                        text-transform: capitalize;
                        font-weight: 400;
                    `,
                    css`
                        margin-bottom: 14px;
                        padding-bottom: 14px;
                        font-size: 24px;
                        text-align: center;
                        margin-top: 0;
                        text-transform: capitalize;
                        font-weight: 400;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    SubTitle: {
        css: css`
            font-size: 14.4px;
            width: 60%;
            margin: -43px auto;
            text-align: center;
            padding-bottom: 101px;
            font-family: "Roboto-medium";
            text-transform: capitalize;
            color: ${getColor("primary.contrast")};
            margin-bottom: -30px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        font-size: 13px;
                        margin: -8px auto;
                        text-align: center;
                        padding-bottom: 77px;
                        margin-bottom: -31px;
                        width: 100%;
                    `,
                    css`
                        font-size: 13px;
                        margin: -8px auto;
                        text-align: center;
                        padding-bottom: 77px;
                        margin-bottom: -31px;
                        width: 100%;
                    `,
                    css`
                        font-size: 13px;
                        margin: -8px auto;
                        text-align: center;
                        padding-bottom: 77px;
                        margin-bottom: -31px;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    main: {
        css: css`
            padding-bottom: 80px;
            padding-top: 80px;
            margin: 100px 0px;

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin-top: 51px;
                        right: 14px;
                    `,
                    css`
                        margin-top: 51px;
                        right: 14px;
                    `,
                    css`
                        margin-top: 51px;
                        right: 14px;
                    `,
                    null,
                    null,
                ])}
        `,
    },
};

const styles = infoCardStyles;

const ExpandCollapseFile: React.FC<Props> = ({ fields }) => {
    const [togglePanel, setTogglePanel] = useState(true);
    const onClickAccord = (test: string) => () => {
        setTogglePanel(!togglePanel);
    };
    return (
        <StyledWrapper
            css={css`
                background: -webkit-linear-gradient(rgb(60 56 56 / 64%), rgb(17 2 2 / 69%)), url(${fields.image});
                padding: 20rem 2.5rem 3.5rem;
                background-position: center;
                background-size: cover;
                position: relative;
                text-align: center;
                margin-top: 50px;
                padding-bottom: 80px;
                padding-top: 80px;
                margin: 40px 0px;
            `}
        >
            <StyledWrapper {...styles.Title}>{fields.title}</StyledWrapper>
            <StyledWrapper {...styles.SubTitle}>{fields.subtitle}</StyledWrapper>
            <GridContainer {...styles.infoCardContainer}>
                {fields.sections.map((section, index) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <GridItem key={index} {...styles.infoCardDiv}>
                        <Accordion headingLevel={2}>
                            <ManagedAccordionSection
                                title={translate(section?.fields?.accordionText)}
                                initialExpanded={true}
                            >
                                <VerticalColumnContainer>
                                    <VerticalColumnCell>
                                        <Link typographyProps={{ ellipsis: true }}>
                                            <StyledWrapper>
                                                {parse(section?.fields?.subAccordionText, parserOptions)}
                                            </StyledWrapper>
                                        </Link>
                                    </VerticalColumnCell>
                                </VerticalColumnContainer>
                            </ManagedAccordionSection>
                        </Accordion>
                    </GridItem>
                ))}
            </GridContainer>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: ExpandCollapseFile,
    definition: {
        group: "Basic",
        displayName: "SE Expand & Collapase Widget",
        fieldDefinitions: [
            {
                name: fields.title,
                displayName: "Tittle",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "General",
                tooltip: "text tip",
                placeholder: "text placeholder",
                isRequired: true,
                sortOrder: 0,
            },
            {
                name: fields.subtitle,
                displayName: "SubTittle",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "General",
                tooltip: "text tip",
                placeholder: "text placeholder",
            },
            {
                fieldType: "Translatable",
                name: fields.image,
                editorTemplate: "ImagePickerField",
                defaultValue: "",
            },

            {
                name: fields.sections,
                editorTemplate: "ListField",
                defaultValue: [],
                fieldType: "General",
                getDisplay: (item: HasFields) => {
                    return item.fields.description;
                },
                fieldDefinitions: [
                    {
                        name: "accordionText",
                        displayName: "Accordion Text",
                        editorTemplate: "TextField",
                        defaultValue: "",
                    },

                    {
                        name: "subAccordionText",
                        editorTemplate: "RichTextField",
                        displayName: "Sub Accordion Text",
                        defaultValue: "",
                    },
                ],
            },
        ],
    },
};

export default widgetModule;
